import {Link} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import Social from "./Social";

const logo = process.env.PUBLIC_URL + "/assets/icon/Logo.svg";

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef(null);
    const burgerRef = useRef(null);

    const headName = () => {
        setIsMenuOpen(false);
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                isMenuOpen &&
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                burgerRef.current &&
                !burgerRef.current.contains(event.target)
            ) {
                setIsMenuOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isMenuOpen]);

    return (
        <header className="header">
            <div className="header__container">
                <Link to="/" className="header__logo" onClick={() => window.scroll(0, 0)}>
                    <img className="logo-img" src={logo} alt="logo"/>
                </Link>
                <button
                    ref={burgerRef}
                    className={`burger ${isMenuOpen ? "open" : ""}`}
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                    <span className="burger-span"></span>
                    <span className="burger-span"></span>
                    <span className="burger-span"></span>
                </button>
                <nav  ref={menuRef} className={`menu  ${isMenuOpen ? "open" : "close"}`}>
                    <Link className="menu__item" to="/get_in_touch" onClick={() => headName()}>LAUNCH A PROJECT</Link>
                    <Link className="menu__item" to="/projects" onClick={() => headName()}>OUR WORK</Link>
                    <Link className="menu__item" to="/our_showreels" onClick={() => headName()}>OUR SHOWREELS</Link>
                    <Link className="menu__item" to="/about" onClick={() => headName()}>ABOUT US</Link>
                    <Link className="menu__item" to="/career" onClick={() => headName()}>CAREER</Link>
                    <Link className="menu__item" to="/contacts" onClick={() => headName()}>CONTACT</Link>
                    <div className="social flex mt-32 space-b">
                        <Social props="light"/>
                    </div>
                </nav>
            </div>
        </header>
    );
};

export default Header;